import { nanoid } from '@reduxjs/toolkit'
// this IN_TESTING_MODE boolean is derived from a combination of comments in the following stackoverflow post
// https://stackoverflow.com/questions/50940640/how-to-determine-if-jest-is-running-the-code-or-not
export const IN_TESTING_MODE = ![0, undefined].includes(process.env.JEST_WORKER_ID) || process.env.NODE_ENV === 'test'
export const TEST_AUTH_TOKEN = nanoid()
export const TEST_ORGANIZATION_ID = '91ac4f9c-0fc4-4fa6-8468-33468c6ef69e'
export const TEST_USER_ID = 'd349cd79-4c76-4760-9527-affa55e4211a';
